(ns frontend.view.modals.layout-editor.view
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.ui.page.nnev.header.editor :as header-editor]
   [frontend.view.entity-viewers.header-fields :as header-fields]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]))

(defonce modal-key :layout-editor-modal-key)

(defn header-layout-editor
  [{:keys [local-state field-defs]}]
  (let [add-row! (fn []
                   (swap! local-state update
                          :field-defs
                          (fn [field-defs]
                            (let [{:keys [field-layout] :as _last-element} (peek field-defs)]
                              ((fnil conj [])
                               field-defs
                               {:fields       {}
                                :field-layout (or field-layout :f-2-2)})))))
        remove-row-v (fn [v i]
                       (into (subvec v 0 i)
                             (subvec v (inc i))))
        remove-row! (fn [i]
                      (swap! local-state update :field-defs remove-row-v i))
        reorder! (fn [old-index new-index]
                   (swap! local-state update
                          :field-defs
                          cu/vector-move
                          old-index
                          new-index))
        select-layout! (fn [i layout]
                         (let [percentages (get header-editor/layout-widths layout)
                               field-count (count percentages)
                               indexes (range field-count)]
                           (swap! local-state update-in
                                  [:field-defs i]
                                  (fn [{:keys [fields] :as field-def}]
                                    (-> field-def
                                        (assoc :field-layout layout)
                                        (update :fields select-keys indexes))))))
        select-field! (fn [i j field]
                        ;;ith row, jth column
                        (swap! local-state assoc-in [:field-defs i :fields j :field] field))]
    (fn [{:keys [entity schema]}]
      (let [field-defs (:field-defs @local-state)
            entity-type (:entity/type entity)]
        [:div
         [header-editor/field-rows
          {:field-defs     field-defs
           :sort-mode?     (:sort-mode? @local-state)
           :schema         schema
           :select-layout! select-layout!
           :select-field!  select-field!
           :reorder!       reorder!
           :remove-row!    remove-row!}]

         (if (:sort-mode? @local-state)
           [:div
            {:class-name "px-4 pt-2"}
            [button/sm-secondary-hollow
             {:on-click (fn []
                          (swap! local-state dissoc :sort-mode?))}
             (loc/tr :save-sort-order)]]

           [:div
            {:class-name "pt-2 flex gap-3"}
            [button/sm-secondary-hollow
             {:on-click add-row!}
             [:i.fas.fa-plus.mr-2]
             (loc/tr :add-row)]
            [button/primary-open
             {:on-click (fn []
                          (swap! local-state assoc :sort-mode? true))}
             (loc/tr :sort)]])]))))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [entity-id field-defs layout-schema header-schema top save-layout!]} props
        local-state (r/atom {:field-defs field-defs})]
    (r/create-class
     {:component-did-mount
      (fn [_]
        ;;unload-handler: just close-modal! for now:
        (routing/add-change-interceptor :layout-editor-interceptor
                                        (fn []
                                          (close-modal!)
                                          false)))
      :component-will-unmount
      (fn [_]
        (routing/remove-change-interceptor :layout-editor-interceptor))
      :reagent-render
      (fn []
        (let [entity (session/get-entity entity-id)]
          [modal/view
           {:visible?      (and shown? topmost?)
            :hide!         close-modal!
            :backdrop      "static"
            :close-button? true}
           (loc/tr :layout-editor)
           [:<>
            [:div
             {:class "px-3 py-2 border border-solid border-base-light-border-paler rounded"}
             [:div
              [header-layout-editor
               {:entity      entity
                :local-state local-state
                :field-defs  field-defs
                :schema      layout-schema}]]]
            [:div
             [:h3
              {:class "pt-4 pb-3 text-bold"}
              (loc/tr :preview)]
             [:div
              {:class "px-3 py-3 border border-solid border-base-light-border-paler rounded"}
              [:div
               {:class "flex"}
               [:div
                top]]
              [:div
               [header-fields/view
                {:entity     entity
                 :field-defs (:field-defs @local-state)
                 :schema     header-schema}]]]]]
           [:<>
            [modal/left-cancel-only close-modal! nil]
            [modal/right-single-button
             nil
             false
             (fn [e]
               (save-layout! (:field-defs @local-state))
               (close-modal!))
             (loc/tr :save-layout)
             nil]]]))})))
